<template>
  <component
    :is="spaPath !== null ? 'router-link' : 'a'"
    v-bind="linkProps"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useSpaNavLink } from '@/member-spa/composables/useSpaNavLink';

const props = defineProps<{ href: string }>();
const { toSpaPath } = useSpaNavLink();
const spaPath = computed(() => toSpaPath(props.href));

const linkProps = computed(() => {
  if (spaPath.value !== null) {
    return { to: spaPath.value, 'active-class': '', 'exact-active-class': '' };
  }
  return { href: props.href };
});
</script>
